<script lang="ts">
  import "../app.css";

  import { navigating } from "$app/state";

  import { shopColours } from "$lib/stores/shopColours";

  import Modal from "$lib/components/Modal.svelte";
  import { Toaster } from "svelte-sonner";

  let { children } = $props();
</script>

<div
  style="--primary-colour: {$shopColours.primary}; --accent-colour: {$shopColours.accent};"
>
  <Modal />
  <Toaster richColors position="top-center" />

  {#if navigating.to}
    <div class="loader"></div>
  {:else}
    {@render children()}
  {/if}
</div>

<style>
  * {
    font-family: Arial, Helvetica, sans-serif;
  }

  .loader {
    position: relative;
    top: 33vh;
    margin: 0px auto;
    border: 16px solid #f3f3f3;
    border-top: 16px solid var(--primary-colour);
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: spin 1.5s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
